// src/json/servicesOverview.json
export const servicesOverviewWaterproofingSystems = {
    eyebrow: "OUR WATERPROOFING",
    titleHighlight: "SERVICES INCLUDE:",
    items: [
        {
            title: "Building Envelope Waterproofing",
            description: "Applying high-performance membranes, sealants, and coatings to safeguard exterior walls, balconies, and façades from water penetration."
        },
        {
            title: "Roof & Deck Waterproofing",
            description: "Installing elastomeric, polyurethane, and torch-on waterproofing systems to prevent leaks, pooling, and weather damage."
        },
        {
            title: "Below-Grade & Foundation Waterproofing",
            description: "Using advanced drainage systems, waterproof barriers, and moisture-resistant coatings to protect underground structures from groundwater infiltration."
        },
        {
            title: "Sealant & Joint Replacement",
            description: "Replacing failing caulking and expansion joints to maintain a tight, leak-proof seal around windows, doors, and concrete joints."
        },
        {
            title: "Balcony & Terrace Waterproofing",
            description: "Sealing concrete, wood, and tile surfaces with liquid-applied or sheet membrane systems for long-term durability and slip resistance."
        },
        {
            title: "Traffic Coatings for Parkades & Walkways",
            description: "Applying high-strength waterproof coatings to protect against heavy traffic wear, chemicals, and weather exposure."
        }
    ],
    imageUrl: "/assets/imgs/services/12WaterproofingSystems/servicesOverview/fondo.jpg",
    button: {
        text: "Request a Quote",
        url: "/quote"
    }
};  